import React from "react";

import { NextSeo } from "next-seo";
import classNames from "classnames";
import { getSEONoFollow, getSEONoIndex } from "../../utils/nextjs/seo";
import { INFOLETTRE_INDEXES, PUB_EVERY_X, withPubEveryX } from "../../configs/pub";

import Layout from "../../layout";

import EmissionCarte from "./emissionCarte";
import Breadcrumb from "../../ui/breadcrumb";
import VODDisponible from "../../ui/vodDisponible";

import styles from "./emissions.module.scss";
import { Emission } from "@/types/emissions";
import Pub from "@/ui/pub";
import { PUBFORMATS } from "@/ui/pub/formats";
import { TYPE_CONTENU } from "@/utils/enums";

type PropTypes = {
  emissions: {
    items: Emission[];
  };
};

const EmissionsPage = ({ emissions }: PropTypes) => {
  const pageTitle = "Émissions";
  const emissionsSorted = emissions?.items?.sort((a, b) => a.nom.localeCompare(b.nom, "fr")) || [];
  const emissionsTop = emissionsSorted.slice(0, INFOLETTRE_INDEXES.EMISSIONS[0]);
  const emissionsWithPub = withPubEveryX(emissionsSorted.slice(INFOLETTRE_INDEXES.EMISSIONS[0]), PUB_EVERY_X.EMISSIONS_LISTE_ALL) as Emission[];

  return (
    <Layout mainBody={false}>
      <NextSeo
        nofollow={getSEONoFollow()}
        noindex={getSEONoIndex()}
        title={pageTitle}
      />

      <div>
        <div className="body page">
          <Breadcrumb title={pageTitle} />
          <div id="main-content" className="content">
            <h1>{pageTitle}</h1>
            <ul className={styles.items}>
              {emissionsTop.map((item) => {
                return (
                  <EmissionCarte
                    item={item}
                    className={styles.itemList}
                    key={item.id}
                  />
                );
              })}
            </ul>
          </div>
        </div>
        <div className="body page">
          <div className={classNames(styles.contentFooter, "content")}>
            <ul className={styles.items}>
              {emissionsWithPub.map((item, index) => {
                if (item.type === TYPE_CONTENU.PUBLICITE && index !== emissionsWithPub.length - 1) {
                  return (
                      <Pub key={`pub-${index}`} format={PUBFORMATS.leaderboardBillboard} />
                  );
                }
                return (
                  <EmissionCarte
                    item={item}
                    className={styles.itemList}
                    key={item.id}
                  />
                );
              })}
            </ul>
            <VODDisponible />
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default EmissionsPage;
